import React from "react";
import * as s from "./lightContainer.module.css";

interface LightContainerProps {
  title?: string;
}

const LightContainer: React.FC<LightContainerProps> = ({ title, children }) => {
  return (
    <div className={s.container}>
      <div className={s.titleView}>
        <span className={s.title}>{title}</span>
      </div>

      <div className={s.body}>{children}</div>
    </div>
  );
};

export { LightContainer };
